<template>
  <div class="px-3 d-flex align-items-center" style="height: 80vh;">
    <b-card class="side-card text-center mx-auto" style="max-width: 400px;" body-class="px-4 py-4">
      <div v-if="loading" role="status">
        <b-spinner class="mb-3" style="width: 2.5rem; height: 2.5rem; color: #163D7D" />
        <p class="fs-20 font-weight-bold mb-2" style="color: #163D7D">Cargando solicitud</p>
        <p class="fs-15 text-muted mb-0">Obteniendo datos de la solicitud, por favor espere...</p>
      </div>

      <div v-else role="alert">
        <div
          class="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
          :style="{ width: '64px', height: '64px', background: error.background }"
        >
          <font-awesome-icon :icon="error.icon" size="2x" :style="{ color: error.color }" />
        </div>
        <p class="fs-12 font-weight-bold text-muted text-uppercase mb-2">{{ error.label }}</p>
        <h5 class="font-weight-bold mb-2" style="color: #163D7D">{{ error.title }}</h5>
        <p class="fs-14 text-muted mb-4">{{ error.message }}</p>

        <b-button v-if="error.retry" variant="outline-primary" class="m-1" @click="$emit('retry')">
          Reintentar
        </b-button>
        <b-button v-else variant="outline-primary" class="m-1" :to="{ name: 'DrawingRequestIndex' }">
          Ir a gestión de planos
        </b-button>
        <b-button variant="outline-secondary" class="m-1" @click="$router.back()">
          Volver
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'DrawingRequestShowState',
  props: {
    loading: { type: Boolean, default: false },
    errorStatus: { type: [Number, String], default: null },
    requestId: { type: Number, default: null }
  },
  computed: {
    error () {
      if (this.errorStatus === 404) {
        return {
          icon: ['fas', 'search'],
          color: '#163D7D',
          background: '#e7edf7',
          label: 'Error 404',
          title: 'La solicitud no existe',
          message: `Es posible que el enlace esté incorrecto o que la solicitud #${this.requestId} no exista`,
          retry: false
        }
      }
      if (this.errorStatus === 403) {
        return {
          icon: ['fas', 'exclamation-triangle'],
          color: '#b54708',
          background: '#fff4e5',
          label: 'Error 403',
          title: 'Acceso restringido',
          message: 'No cuenta con los permisos necesarios',
          retry: false
        }
      }
      return {
        icon: ['fas', 'exclamation-triangle'],
        color: '#b42318',
        background: '#fdecea',
        label: 'Error',
        title: 'No se pudo cargar la solicitud',
        message: 'Intente de nuevo en unos segundos',
        retry: true
      }
    }
  }
}
</script>
